import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/@mui/utils/capitalize/index.js';

var require$$5 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$5 as default };
